"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.nativeRouter = exports.nativeRouterResultSchema = exports.nativeRouterArgsSchema = void 0;
var zod_1 = require("zod");
var common_1 = require("./common");
// Argument schema for nativeRouter
exports.nativeRouterArgsSchema = zod_1.z.object({
    description: zod_1.z
        .string()
        .nullable()
        .optional()
        .describe('Optional description of the workflow branching for documentation purposes'),
});
// Result schema for nativeRouter - no output (structural node only)
exports.nativeRouterResultSchema = zod_1.z.any();
// Tool definition
exports.nativeRouter = (0, common_1.createToolMetadata)({
    id: 'nativeRouter',
    displayName: 'Router',
    displayDescription: 'Structural node for conditional workflow branching',
    category: 'native',
    color: common_1.BRAND_COLORS.NATIVE,
    backgroundColor: (0, common_1.createBgColor)(common_1.BRAND_COLORS.NATIVE),
    icon: 'route',
    argsSchema: exports.nativeRouterArgsSchema,
}, exports.nativeRouterResultSchema);
